import React from "react";
import { LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { Popconfirm, Tooltip } from "antd";

const Profile = () => {
  const rawData =
    sessionStorage.getItem("merchantData") ||
    localStorage.getItem("merchantData");
  const parsedMerchantData = JSON.parse(rawData);
  const isImpersonation = sessionStorage.getItem("isImpersonation") === "true";

  const logOut = () => {
    if (isImpersonation) {
      sessionStorage.clear();
    } else {
      localStorage.clear();
    }
    window.location.href = "/";
  };

  return (
    <div className="w-[200px]fixed right-0 bottom-0 w-full gap-3 flex items-center justify-between bg-white p-4 border-t border-gray-200 shadow-inner">
      <div className="flex items-center gap-3">
        <div className="bg-gray-100 p-2 rounded-full">
          <UserOutlined className="text-xl text-gray-700" />
        </div>
        <Tooltip title={parsedMerchantData?.name || "Хэрэглэгч"}>
          <h2 className="text-md font-semibold text-gray-800 truncate max-w-[200px]">
            {String(parsedMerchantData?.name).substring(0, 5) || "Хэрэглэгч"}
          </h2>
        </Tooltip>
      </div>

      <Popconfirm
        title="Та гарахдаа итгэлтэй байна уу?"
        onConfirm={logOut}
        okText="Тийм"
        cancelText="Үгүй"
      >
        <button className="flex items-center gap-1 text-red-500 hover:text-red-600 transition">
          <LogoutOutlined />
          <span className="text-sm font-medium">Гарах</span>
        </button>
      </Popconfirm>
    </div>
  );
};

export default Profile;
